import {extractDocs} from '~/utils/transform-payload'

export function useEmployeeTestimonials() {
  const sdk = usePayloadSdk()

  const fetch = async () => {
    const response = await sdk.find({
      collection: 'employeeTestimonials',
      depth: 1, // Populates portrait relationship
      limit: 1000,
    })

    return extractDocs(response)
  }

  return {
    fetch,
  }
}
